function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00667 10.6489L3.00346 10.2727L4.00667 10.6489ZM5.693 9.07143H6V6.92857H5.693V9.07143ZM15.5 10.9286H4.943V13.0714H15.5V10.9286ZM5.00988 11.0251L5.75988 9.02508L3.75346 8.27267L3.00346 10.2727L5.00988 11.0251ZM4.943 10.9286C4.94995 10.9286 4.96373 10.931 4.97768 10.9386C4.98971 10.9451 4.99716 10.9527 5.00171 10.9593C5.00626 10.9659 5.01083 10.9755 5.0127 10.9891C5.01487 11.0048 5.01232 11.0186 5.00988 11.0251L3.00346 10.2727C2.49564 11.6269 3.49672 13.0714 4.943 13.0714V10.9286ZM5.693 6.92857C4.82954 6.92857 4.05664 7.46419 3.75346 8.27267L5.75988 9.02508C5.74943 9.05296 5.72277 9.07143 5.693 9.07143V6.92857Z",
  fill: "#ffffff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 2C15 3 13 4 14 5",
  stroke: "#ffffff",
  strokeWidth: 2.14286,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2887 2C11.2887 3 9.2887 4 10.2887 5",
  stroke: "#ffffff",
  strokeWidth: 2.14286,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.99998 9.07157H15.5972L14.111 14.5211C14.8041 13.5489 15.7799 12.7921 16.9185 12.371L17.8183 9.07157H18.1816L18.9803 12.0001C18.9869 12.0001 18.9934 12.0001 19 12.0001C19.8261 12.0001 20.6131 12.167 21.3293 12.469L20.2346 8.45511C19.9888 7.55391 19.1703 6.92871 18.2362 6.92871H17H5.99998V9.07157ZM13.3672 20.0716C13.1297 19.4259 13 18.7281 13 18.0001C13 17.9763 13.0001 17.9525 13.0004 17.9287H4.4204L6.03018 12.2945L3.96978 11.7058L2.33398 17.4311C1.95591 18.7543 2.9495 20.0716 4.32571 20.0716H13.3672Z",
  fill: "#ffffff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.9958 17.9979C22.9958 20.2059 21.2059 21.9958 18.9979 21.9958C16.7899 21.9958 15 20.2059 15 17.9979C15 15.7899 16.7899 14 18.9979 14C21.2059 14 22.9958 15.7899 22.9958 17.9979ZM18 15H18.9992V18H20.5049V18.9979H18V18.503V18V15Z",
  fill: "#ffffff"
});

var SvgIcoDefferedTogo24White = function SvgIcoDefferedTogo24White(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoDefferedTogo24White, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-deffered_togo-24-white.8342604f.svg";
export { ForwardRef as ReactComponent };